import toast from "react-hot-toast";

const BASE = "/api/v1/creative-analysis";

class CreativeAnalysisAPIs {
  static async handleListReviewTags({
    axiosPrivate,
    tab,
    filter,
    category,
    reviewed_by,
    date_from,
    date_to,
    limit = 20,
    offset = 0,
  }) {
    try {
      const params = new URLSearchParams({
        ...(tab && { tab }),
        ...(filter && { filter }),
        ...(category && { category }),
        ...(reviewed_by && { reviewed_by }),
        ...(date_from && { date_from }),
        ...(date_to && { date_to }),
        ...(limit != null && { limit }),
        ...(offset != null && { offset }),
      });
      const res = await axiosPrivate.get(
        `${BASE}/taxonomy/review/?${params.toString()}`
      );
      const list = res?.data?.data ?? [];
      return {
        data: Array.isArray(list) ? list : [],
        count: res?.data?.count ?? 0,
        tabCounts: res?.data?.tab_counts ?? {},
        filterCounts: res?.data?.filter_counts ?? {},
      };
    } catch (e) {
      toast.error(e?.response?.data?.error_message || e?.message);
      return { data: [], count: 0, tabCounts: {}, filterCounts: {} };
    }
  }

  static async handleGetTaxonomyOptions({ axiosPrivate, category }) {
    try {
      const params = new URLSearchParams({ ...(category && { category }) });
      const q = params.toString();
      const res = await axiosPrivate.get(
        q ? `${BASE}/taxonomy/options/?${q}` : `${BASE}/taxonomy/options/`
      );
      return res?.data?.data ?? {};
    } catch (e) {
      toast.error(e?.response?.data?.error_message || e?.message);
      throw e;
    }
  }

  /** Approve, or correct with a reason per changed field. */
  static async handleReviewTag({ axiosPrivate, id, payload }) {
    try {
      const res = await axiosPrivate.post(
        `${BASE}/taxonomy/tags/${id}/review/`,
        payload
      );
      return res?.data?.data ?? res?.data;
    } catch (e) {
      toast.error(e?.response?.data?.error_message || e?.message);
      throw e;
    }
  }
}

export default CreativeAnalysisAPIs;
